import { Typography, styled } from '@mui/material';

export const FieldCaption = styled(Typography)(({ theme }) => ({
  display: 'block',
  marginTop: theme.spacing(0.5),
  color: theme.palette.text.secondary
}));
